












import Vue, { PropOptions } from 'vue';
import {routes} from '@/router'

export default Vue.extend({
  name: 'TopBar',
  props: {
    sendFlag: Boolean,
  },
  data() {
    return {
      modalShowFlag: false,
      roleText: '',
    };
  },
  computed: {
    ROUTES(): any[] { return routes.filter((v) => (v.topbar))},
  },
  methods: {
    onClickLogout() {
      this.$emit('logout');
      this.$router.push(`/`, () => {});
    },
  },
});

